export const useIsMounted = (defaul: boolean = false) => {
  const isMounted = ref<boolean>(defaul);
  onMounted(() => {
    isMounted.value = true;
  });
  return { isMounted };
};
